import React from 'react'

import { Container, Switch, Wrapper } from './styles'

import IProps from './props'

const SwitchAvailability = ({ available, onSwitch }: IProps) => (
  <Wrapper>
    <Container onClick={onSwitch}>
      <div className="first-div">Disponível</div>
      {' '}
      <div>Indisponível</div>
      <Switch
        className={available ? 'available' : 'unavailable'}
      >
        {available ? 'Disponível' : 'Indisponível'}
      </Switch>
    </Container>
  </Wrapper>
)

export default SwitchAvailability
